/*
function Example() {
	// please note this is for demonstration purposes only
	// within XbyK, component-specific JavaScript is typically called from within the component
	// this is done to make sure the JavaScript is fired as needed when the component is on a page OR in a modal

	// the rate at which the parallax image moves relative to scroll can be updated
	// 1: will increase the size of the image to fill the entire screen* and will appear to not move
	// 2: will increase the size of the image to 2x the size of the screen* and will move at half the rate of scroll
	// any numeric value can be used

	// * it's more intricate than that - the image is sized up to cover every vertical pixel the component may appear on
	// * so if the component is position at the top of the page and will never reach the bottom of the page, the image doesn't need to fill 100% of the browser
	// * if the component starts below the fold, the image will need to be larger than the heigh tof the browser
	const divisor = 2;

	$(".widget-masthead").each(function () {
		$(this).children(".widget-masthead-image").ZagParallax({ divisor: divisor });
	});
}
*/

(function ($) {

	$.ZagParallax = function (element, options) {

		options = $.extend({}, $.ZagParallax.defaultOptions, options);

		var Component = element;

		if (Component.children(".zag-parallax-bg").length) {

			Component.addClass("zag-parallax");
			ZagParallaxSet(Component, options.divisor);

			$(window).on("resize scroll", function () {
				ZagParallaxSet(Component, options.divisor);
			});
		}
	};

	function ZagParallaxSet(Component, divisor) {

		var bg = Component.children(".zag-parallax-bg");

		// parallax coverage is different for components that appear above vs. below the fold
		// if bottom of component is above the fold...
		var bgScale = Component.offset().top + Component.outerHeight() < $(window).height() ? Component.offset().top : $(window).height() - Component.outerHeight();
		var bgHeight = Component.outerHeight() + bgScale / divisor
		var bgTop = ($(window).scrollTop() - Component.offset().top) / divisor;

		bg.height(bgHeight);
		bg.css({ marginTop: bgTop });

	}

	$.fn.ZagParallax = (function (options) {
		return this.each(function () {
			(new $.ZagParallax($(this), options));
		});
	});

	$.ZagParallax.defaultOptions = { divisor: 1 };

})(jQuery);